export default {
    supplierName: "Shop Name",
    mainCategory: "Business Category",
    contactName: "Contact Name",
    contactPhoneNumber: "Contact Phone Number",
    warehouseAddr: "Warehouse Addr",
    setPassword: "Set Password",
    confirmPassword: "Confirm Password",
    legalPersonsname: "Legal Persons name",
    legalPersonPhoneNumber: "Legal Person Phone Number",
    legalPersonsIDCard: "Legal Persons ID Card",
    IDPhoto: "Id Photo",
    whetherThreeCertificatesAreInOne: "Whether Three Certificates Are In One",
    unifiedSocialCreditCode: "Unified Social Credit Code",
    operatingPeriod: "Operating Period",
    businessLicense: "Business License",
    long: "Long"
}